<template>
  <header class="masthead pt-5 bg-light pb-5">
    <b-container class="px-5">
        <b-row class="gx-5 align-items-center">
            <b-col lg="6">
                <b-row>
                    <b-col cols="12" class="text-center text-lg-start">
                      <h1 class="display-1 lh-1 mb-3">{{event.name}}</h1>
                      <p class="lead font-weight-normal text-muted mb-5">{{title_date}}, {{title_time}} {{event.campus}}</p>
                    </b-col>
                    <b-col cols="12" v-if="myName" class="text-center text-lg-start">
                      <h2 class="text-center text-uppercase text-primary">{{myName}}</h2>
                    </b-col>
                    <b-col cols="12" v-if="myName" class="text-center text-lg-start">
                      <b-button-group size="lg" class="pt-5 pb-5">
                        <b-button :disabled="has_active_sessionError != null || event_finishedError != null || message != null" variant="success" @click="checkOut">Registrar Salida</b-button>
                      </b-button-group>
                    </b-col>
                </b-row>
            </b-col>
            <b-col lg="6" v-if="message">
              <h1 class="display-1 lh-1 mb-3 text-success text-center">{{this.message}}</h1>
            </b-col>
            <b-col lg="6" v-if="not_found">
              <h1 class="display-1 lh-1 mb-3 text-danger text-center">{{this.not_found}}</h1>
            </b-col>
            <b-col lg="6" v-if="event_finishedError">
              <h1 class="display-1 lh-1 mb-3 text-danger text-center">{{event_finishedError}}</h1>
            </b-col>
            <b-col lg="6" v-if="has_active_sessionError">
              <h1 class="display-1 lh-1 mb-3 text-danger text-center">{{has_active_sessionError}}</h1>
            </b-col>
            <b-col lg="6" offset-lg="3">
              <b-button block @click="$router.push({name:'Home'})" variant="primary" class="pt-3 pb-3 text-uppercase">
                Sitio Principal
              </b-button>
            </b-col>
        </b-row>
    </b-container>
  </header>
</template>

<script>
// @ is an alias to /src

import Vue from 'vue'
import moment from 'moment'

export default Vue.extend({
  name: 'Home',
  components: {
  },
  data() {
    return {
      errors: [],
      not_found: null,
      my_data: null,
      message: null
    }
  },
  created() {
  },
  methods: {
    checkOut() {
      let loader = this.$loading.show()
      this.$store.dispatch(
        'post', 
        {
          url:'/assistants/assistance', 
          data: {
            key_id: this.$route.params.k,
            site: 'main',
            is_entry: 0
          }, 
          headers:{}
        }
      ).then((resp) => {
          console.log(resp.data)
          loader.hide()
          this.message = resp.data
          this.$nextTick(() => {
              
          })
      }).catch(err => {
          console.log(err)
          console.log(typeof(err.error))
          if(typeof(err.error) == 'string') this.not_found = 'Registro no encontrado'
          this.errors = err.errors
          loader.hide()
          //if(err.error) alert(err.error)
      })
    },
    loadMyData() {
      this.$store.dispatch(
        'post', {
          url: '/assistants/my_data', 
          data: {
            key_id: this.$route.params.k, 
          }, 
          headers:{}
        }
      ).then((resp) => {
          this.my_data = resp.data
        })
        .catch(err => {
          console.log(err)
          if(typeof(err.error) == 'string') this.not_found = 'Registro no encontrado'
        })
      },
  },
  beforeMount () {
    console.log(this.$route.params.k)
    this.loadMyData()
  },
  mounted () {
    console.log(this.$route.params.k)
  },
  computed: {
    myName: function() {
      if(!this.my_data) return null
      return this.my_data.name 
        + ' ' 
        + this.my_data.last_name 
        + ' '
        + this.my_data.mother_last_name
        + ' (' + this.my_data.email +')'
    },
    event : function() { return this.$store.getters.event },
    title_date: function() {
      let resp = ''
      if(this.event.start_date) resp += moment(this.event.start_date).format('DD/MM/YYYY')
      return resp
    },
    title_time: function() {
      let resp = ''
      if(this.event.start_date) resp += moment(this.event.start_date).format('hh:mm A')
      return resp
    },
    event_finishedError: function () {
      if(this.errors && this.errors.event_finished) return this.errors.event_finished[0]
      return null
    },
    has_active_sessionError: function () {
      if(this.errors && this.errors.has_active_session) return this.errors.has_active_session[0]
      return null
    },
  },
  watch: {
    event(newValue, oldValue) {
      if(!newValue.demo_mode) {
        this.video_start = false
      }
    }
  },
})
</script>

<style lang="scss" scoped>
@import '../styles/app';

.masthead {
  min-height: 70vh !important;
}
</style>
